export default __webpack_public_path__ + "static/media/people10.4a47b904.png";